import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useHistory } from "react-router-dom";
import { notification } from "antd";
import { Routes } from "../../../../../AppRoutes";
import { ITToolRequestService } from "../../../../../services/it-tools-request/itToolRequest.service";

export const useCreateDFS = () => {
  const queryClient = useQueryClient();
  const history = useHistory();

  const { mutate, ...restMutation } = useMutation({
    mutationFn: (body: any) => ITToolRequestService.addITToolRequest(body),
  });

  const createDFSRequest = (body: any, options?: { onSuccess?: (res: any) => void }) => {
    mutate(body, {
      onSuccess(res: any) {
        queryClient.invalidateQueries({ queryKey: ["demand-for-supplies-requests"] });
        history.push(Routes.demandForSuppliesDetailPage.path.replace(":id", res.id));
        notification.success({
          message: "Thành công!",
          description: `Tạo yêu cầu thành công.`,
        });
        if (options?.onSuccess) options.onSuccess(res);
      },
      onError() {
        notification.error({
          message: "Thất bại",
          description: `Tạo yêu cầu thất bại.`,
        });
      },
    });
  };

  return { mutate, createDFSRequest, restMutation };
};
